import { Injectable } from '@angular/core';
import { Feedback, FeedbackServiceEnum, FeedbackType } from '../models/feedback.model';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Store } from '@ngxs/store';
import { User } from '../models/user.model';
import { UserSelectors } from '../states/user/user.selectors';
import { Dealer } from '../models/dealer.model';
import { DealerStateSelectors } from '../states/dealer/dealer-state.selectors';
import { OrderSelectors } from '@app/sales/states/order/order.selectors';

export type FeedbackModel = {
  text: string;
  rating: number;
  contactEmail?: string;
  deviceDetectorService: DeviceDetectorService;
  store: Store;
  feedbackType: FeedbackType;
};

@Injectable({
  providedIn: 'root',
})
export class FeedbackHelperService {
  public static getDefaultFeedback(options: FeedbackModel): Feedback {
    const { text, rating, deviceDetectorService, store, contactEmail, feedbackType } = options;
    const newFeedback = new Feedback();
    const deviceInfo = deviceDetectorService.getDeviceInfo();
    const user = store.selectSnapshot<User>(UserSelectors.getUser);
    const activeDealer = store.selectSnapshot<Dealer>(DealerStateSelectors.activeDealer);
    const orderId = store.selectSnapshot<string>(OrderSelectors.currentOrderServiceId);

    newFeedback.text = text;
    newFeedback.rating = rating;

    newFeedback.service = FeedbackServiceEnum.Diego;
    newFeedback.clientVersion = '0.1';

    newFeedback.canBeContacted = true;

    newFeedback.deviceModel = deviceInfo.device;
    newFeedback.browser = deviceInfo.browser;
    newFeedback.userAgent = deviceInfo.userAgent;
    newFeedback.deviceOperatingSystem = deviceInfo.os;
    newFeedback.deviceOperatingSystemVersion = deviceInfo.os_version;

    newFeedback.viewportWidth = window.innerWidth;
    newFeedback.viewportHeight = window.innerHeight;

    newFeedback.deviceLanguage = navigator.language;

    newFeedback.orderId = orderId;
    newFeedback.userId = user.sub;
    newFeedback.dealerId = activeDealer.dealerId;
    newFeedback.dealerName = activeDealer.dealerName;

    newFeedback.contactEmail = contactEmail;
    newFeedback.feedbackType = feedbackType;

    return newFeedback;
  }
}
